import { Dropdown } from "react-bootstrap";
import { getVehicleStatusBadgeClass } from "../utils/vehicle.utils";

const VehiclesTable = ({ vehicles, onEdit, onDelete, isDeleting }) => {
  return (
    <div className="table-responsive">
      <table className="table table-striped">
        <thead>
          <tr>
            <th>#</th>
            <th>Registration</th>
            <th>Make</th>
            <th>Model</th>
            <th>Year</th>
            <th>Category</th>
            <th>Price</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {vehicles.map((vehicle, index) => (
            <tr key={vehicle._id || `${vehicle.registrationNumber}-${index}`}>
              <td>{index + 1}</td>
              <td>{vehicle.registrationNumber || "-"}</td>
              <td>{vehicle.make || "-"}</td>
              <td>{vehicle.model || "-"}</td>
              <td>{vehicle.year || "-"}</td>
              <td>{vehicle.category || "-"}</td>
              <td>{vehicle.price ?? "-"}</td>
              <td>
                <span className={getVehicleStatusBadgeClass(vehicle.status)}>
                  {vehicle.status || "inactive"}
                </span>
              </td>
              <td>
                <Dropdown>
                  <Dropdown.Toggle variant="link" className="p-0 text-decoration-none">
                    &#x2022;&#x2022;&#x2022;
                  </Dropdown.Toggle>
                  <Dropdown.Menu align="end">
                    <Dropdown.Item onClick={() => onEdit(vehicle._id)} disabled={!vehicle._id}>
                      Edit
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => onDelete(vehicle)}
                      className="text-danger"
                      disabled={!vehicle._id || isDeleting}
                    >
                      Delete
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default VehiclesTable;
